module.exports = __webpack_public_path__ + "static/img/shiye_.d6ed16c1.png";